/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, InteractionManager, Platform } from 'react-native';
import Images from '../images';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDDevice, JDText, JDImage } from '@jdreact/jdreact-core-lib';
import InfoTitle from './InfoTitle';
//@ts-ignore
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import store from '../services/goodsContrastPageStore/store';
import { IPublicPraiseTab } from '../services/goodsContrastPageStore/domain';
import FlexImage from './FlexImage';
import Loading from './Loading';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  main: {
    paddingLeft: getRpx(37),
    paddingTop: getRpx(38),
    paddingBottom: getRpx(20),
  },
  commonLine: {
    width: 1,
    height: getRpx(40),
    backgroundColor: '#F2F2F2',
  },
  paramsItem: {
    justifyContent: 'space-between',
    width: getRpx(322),
    maxWidth: getRpx(322),
    paddingLeft: getRpx(25),
    marginRight: getRpx(10),
  },
  mainItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mainInfo: {
    marginBottom: getRpx(30),
  },
  mainTitle: {
    color: '#262626',
    fontSize: getRpx(30),
    height: getRpx(42),
    lineHeight: getRpx(42),
    fontWeight: 'bold',
    marginBottom: getRpx(16),
  },
  mainList: {
    flexDirection: 'row',
  },
  block: {
    width: '100%',
    height: getRpx(24),
    backgroundColor: '#F2F2F2',
  },
  normalText: {
    maxWidth: getRpx(250),
    lineHeight: getRpx(37),
  },
  logList: {
    flexDirection: 'column',
  },
  logText: {
    color: '#262626',
    height: getRpx(37),
    lineHeight: getRpx(37),
    fontSize: getFontSize(26),
  },
  sendedText: {
    fontSize: getFontSize(22),
    height: getRpx(30),
    lineHeight: getRpx(30),
    color: '#8C8C8C',
  },
  medalList: {
    flexDirection: 'column',
  },
  medalItemBg: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    height: getRpx(32),
    paddingRight: getRpx(14),
    paddingTop: getRpx(4),
    paddingBottom: getRpx(4),
    borderRadius: getRpx(18),
  },
  medalItem: {
    flexDirection: 'row',
    marginBottom: getRpx(12),
  },
  medalIcon: {
    width: getRpx(32),
    height: getRpx(32),
    marginRight: getRpx(8),
  },
  medalText: {
    color: '#FF7163',
    height: getRpx(24),
    paddingTop: Platform.OS == 'android' ? getRpx(4) : 0,
    alignItems: 'center',
    lineHeight: getRpx(24),
    fontSize: getFontSize(22),
  },
  pointList: {
    flexDirection: 'column',
  },
  commentList: {
    flexDirection: 'column',
    width: '100%',
  },
  commentsLink: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  commentText: {
    color: '#8C8C8C',
    height: getRpx(30),
    lineHeight: getRpx(30),
    fontSize: getRpx(22),
  },
  moreComments: {
    width: getRpx(6),
    height: getRpx(13),
    marginLeft: getRpx(8),
  },
  iconList: {
    flexDirection: 'row',
    width: '100%',
    flexWrap: 'wrap',
  },
  icon: {
    height: getRpx(26),
    marginRight: getRpx(13),
    marginBottom: getRpx(13),
  },
});
interface IStoreProps {
  store: {
    tabCtrlIndex: number;
    golbalSku: string;
    publicPraiseTab: IPublicPraiseTab;
    SamePropsCheck: boolean;
  };
}
interface IProps extends IStoreProps {
  isReadOnly: boolean;
  index: number;
}
interface IState {
  publicPraiseTab: IPublicPraiseTab | null;
}
class TabConGoodsOpinions extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      publicPraiseTab: null,
    };
  }
  componentDidMount() {
    const {
      store: { publicPraiseTab },
    } = this.props;
    setTimeout(() => {
      InteractionManager.runAfterInteractions(() => {
        this.setState({ publicPraiseTab });
      });
    }, 0);
  }
  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.store.publicPraiseTab) {
      this.setState({ publicPraiseTab: nextProps.store.publicPraiseTab });
    }
  }
  render() {
    const { store, index } = this.props;
    const { SamePropsCheck, tabCtrlIndex } = store;
    const { publicPraiseTab } = this.state;
    publicPraiseTab && console.log(publicPraiseTab.deliverInfos);
    let hideSame = SamePropsCheck && index === tabCtrlIndex;
    if (!publicPraiseTab) {
      return (
        <View style={{ height: getRpx(500) }}>
          <Loading />
        </View>
      );
    }
    return (
      <View style={styles.wrap}>
        {hideSame &&
        publicPraiseTab.iconInfosHideFlag &&
        publicPraiseTab.deliverInfosHideFlag &&
        publicPraiseTab.serviceInfosHideFlag ? null : (
          <View style={styles.main}>
            <InfoTitle title={'品牌服务'} marginBottom={32} />
            {hideSame && publicPraiseTab.iconInfosHideFlag ? null : (
              <View style={styles.mainInfo}>
                <JDText style={styles.mainTitle}>品牌</JDText>
                <View style={styles.mainList}>
                  {publicPraiseTab.iconInfos &&
                    publicPraiseTab.iconInfos.map((iconItem, index) => {
                      return (
                        <View style={[styles.mainItem, styles.paramsItem]}>
                          <View style={styles.iconList}>
                            {iconItem.iconList && iconItem.iconList.length > 0 ? (
                              iconItem.iconList.map((icon) => {
                                if (Platform.OS == 'web') {
                                  return <JDImage source={{ uri: icon }} style={styles.icon} key={icon}></JDImage>;
                                } else {
                                  return (
                                    <FlexImage
                                      height={getRpx(26)}
                                      uri={icon}
                                      key={icon}
                                      style={styles.icon}
                                    ></FlexImage>
                                  );
                                }
                              })
                            ) : (
                              <JDText style={styles.logText}>-</JDText>
                            )}
                          </View>
                          {index == publicPraiseTab.iconInfos.length - 1 ? null : (
                            <View style={styles.commonLine}></View>
                          )}
                        </View>
                      );
                    })}
                </View>
              </View>
            )}
            {hideSame && publicPraiseTab.deliverInfosHideFlag ? null : (
              <View style={styles.mainInfo}>
                <JDText style={styles.mainTitle}>物流服务</JDText>

                <View style={styles.mainList}>
                  {publicPraiseTab.deliverInfos.map((Info, index) => {
                    return (
                      <View style={[styles.mainItem, styles.paramsItem]} key={Info}>
                        <View style={styles.logList}>
                          <JDText style={styles.normalText}>{Info ? Info : '-'}</JDText>
                          {/* <JDText style={styles.sendedText}>{date.name}</JDText> */}
                        </View>
                        {index == publicPraiseTab.deliverInfos.length - 1 ? null : (
                          <View style={styles.commonLine}></View>
                        )}
                      </View>
                    );
                  })}
                </View>
              </View>
            )}
            {hideSame && publicPraiseTab.serviceInfosHideFlag ? null : (
              <View style={styles.mainInfo}>
                <JDText style={styles.mainTitle}>优质服务</JDText>
                <View style={styles.mainList}>
                  {publicPraiseTab.promiseIconInfoVoList.map((infoList, index) => {
                    return (
                      <>
                        <View style={[styles.mainItem, styles.paramsItem]}>
                          <View style={styles.logList}>
                            {infoList.length > 0 ? (
                              infoList.map((info, idx) => {
                                return <JDText style={styles.normalText}>{info.name ? info.name : '-'}</JDText>;
                              })
                            ) : (
                              <JDText>-</JDText>
                            )}
                          </View>
                          {index == publicPraiseTab.promiseIconInfoVoList.length - 1 ? null : (
                            <View style={styles.commonLine}></View>
                          )}
                        </View>
                      </>
                    );
                  })}
                </View>
              </View>
            )}
          </View>
        )}

        {hideSame &&
        publicPraiseTab.iconInfosHideFlag &&
        publicPraiseTab.deliverInfosHideFlag &&
        publicPraiseTab.serviceInfosHideFlag ? null : (
          <View style={styles.block}></View>
        )}
        <View style={styles.main}>
          {hideSame && publicPraiseTab.rankInfosHideFlag && publicPraiseTab.goodCommentInfosHideFlag ? null : (
            <InfoTitle title={'口碑评价'} marginBottom={32} />
          )}
          {hideSame && publicPraiseTab.rankInfosHideFlag ? null : (
            <View style={styles.mainInfo}>
              <JDText style={styles.mainTitle}>获得勋章</JDText>
              <View style={styles.mainList}>
                {publicPraiseTab.rankInfos &&
                  publicPraiseTab.rankInfos.map((rank, idx) => {
                    return (
                      <View style={[styles.mainItem, styles.paramsItem]}>
                        <View style={styles.medalList}>
                          {rank.length > 0 ? (
                            rank.map((info) => {
                              return (
                                <View style={styles.medalItem}>
                                  <LinearGradient
                                    colors={['rgba(254,247,247,1)', 'rgba(255,226,222,1)']}
                                    start={{ x: 0, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                    style={styles.medalItemBg}
                                  >
                                    <JDImage source={Images.contrast.medalIcon} style={styles.medalIcon}></JDImage>
                                    <JDText style={styles.medalText}>{info}</JDText>
                                  </LinearGradient>
                                </View>
                              );
                            })
                          ) : (
                            <JDText style={styles.medalText}>-</JDText>
                          )}
                        </View>
                        {idx == publicPraiseTab.rankInfos.length - 1 ? null : <View style={styles.commonLine}></View>}
                      </View>
                    );
                  })}
              </View>
            </View>
          )}
          {hideSame && publicPraiseTab.goodCommentInfosHideFlag ? null : (
            <View style={styles.mainInfo}>
              <JDText style={styles.mainTitle}>评价</JDText>
              <View style={styles.mainList}>
                {publicPraiseTab.goodCommentInfos.map((comment, idx) => {
                  return (
                    <View style={[styles.mainItem, styles.paramsItem]}>
                      <View style={styles.commentList}>
                        <JDText style={styles.normalText}>{comment}</JDText>
                        {/* {!isReadOnly ? (
                        <View style={styles.commentsLink}>
                          <JDText style={styles.commentText}>查看更多评价</JDText>
                          <JDImage source={Images.contrast.moreComments} style={styles.moreComments}></JDImage>
                        </View>
                      ) : null} */}
                      </View>
                      {idx == publicPraiseTab.goodCommentInfos.length - 1 ? null : (
                        <View style={styles.commonLine}></View>
                      )}
                    </View>
                  );
                })}
              </View>
            </View>
          )}
        </View>
      </View>
    );
  }
}
const TabConGoodsOpinionsOberver = observer(TabConGoodsOpinions);
const TabConGoodsOpinionsWapper = (props: IProps) => <TabConGoodsOpinionsOberver {...props} store={store} />;
export default TabConGoodsOpinionsWapper;
